import { linkToClassPage } from "../../links";

export function linkToInviteStudentsToClassPage(classId?: string) {
  return `${linkToClassPage(classId)}/invite-students`;
}

export function linkToInviteStudentsQrCode(classId?: string) {
  return `${linkToInviteStudentsToClassPage(classId)}/QrCode`;
}
